/**
 * Collection enhancements - emoji stripping & description animation
 */
(function() {
  'use strict';

  // Emoji regex with fallback for older browsers
  let emojiRegex;
  try {
    // Modern regex using Unicode property escapes
    emojiRegex = /[\p{Extended_Pictographic}\p{Emoji_Component}\u200D\uFE0F]/gu;
  } catch (e) {
    // Fallback for browsers without Unicode property escape support
    emojiRegex = /[\u{1F300}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F000}-\u{1F02F}\u{1F0A0}-\u{1F0FF}\u{1F100}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{1F900}-\u{1F9FF}\u{1FA70}-\u{1FAFF}\u{FE00}-\u{FE0F}\u200D]/gu;
  }

  /**
   * Strip emoji characters from text
   * @param {string} text - Text to process
   * @returns {string} Text without emoji
   */
  function stripEmoji(text) {
    if (!text) return '';
    return text.replace(emojiRegex, '').trim();
  }

  /**
   * Apply emoji filtering to elements with [data-strip-emoji-source]
   * @param {Element} root - Root element to search within
   */
  function applyEmojiFilter(root) {
    root = root || document;
    const elements = root.querySelectorAll('[data-strip-emoji-source]');
    
    elements.forEach(function(element) {
      // Skip if already processed
      if (element.hasAttribute('data-emoji-stripped')) return;
      
      const originalText = element.getAttribute('data-strip-emoji-source');
      if (originalText) {
        element.textContent = stripEmoji(originalText);
        element.setAttribute('data-emoji-stripped', 'true');
      }
    });
  }

  /**
   * Initialize collection description animation
   * @param {Element} root - Root element to search within
   */
  function initCollectionDescriptionAnimation(root) {
    root = root || document;
    const details = root.querySelectorAll('details.collection-description--toggle');
    
    details.forEach(function(detail) {
      // Skip if already initialized
      if (detail.hasAttribute('data-animation-init')) return;
      
      const content = detail.querySelector('.collection-description__content');
      if (!content) return;
      
      detail.addEventListener('toggle', function() {
        if (detail.open && window.Animation) {
          // Animate the content on open
          content.animate([
            { opacity: 0, transform: 'translateY(12px)' },
            { opacity: 1, transform: 'translateY(0)' }
          ], {
            duration: 350,
            easing: 'ease',
            fill: 'both'
          });
        }
      });
      
      detail.setAttribute('data-animation-init', 'true');
    });
  }

  /**
   * Initialize all enhancements
   */
  function init() {
    applyEmojiFilter();
    initCollectionDescriptionAnimation();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run on Shopify section events
  document.addEventListener('shopify:section:load', function(event) {
    applyEmojiFilter(event.target);
    initCollectionDescriptionAnimation(event.target);
  });

  document.addEventListener('shopify:section:select', function(event) {
    applyEmojiFilter(event.target);
    initCollectionDescriptionAnimation(event.target);
  });
})();
